'use client'

import { TimeRecordingPlayIcon } from '@repo/ui/TimeRecordingPlayIcon'
import PropTypes from 'prop-types'

export const PlayPauseIcon = ({ sx, isPlaying = false }) => {
  const width = sx?.width || 28
  const height = sx?.height || 28

  return (
    <div style={{ position: 'relative', width: `${width}px`, height: `${height}px` }} data-testid="PlayPauseIcon">
      <TimeRecordingPlayIcon
        playing={isPlaying}
        sx={{
          width: `${width}px`,
          height: `${height}px`,
          position: 'relative',
          zIndex: 0,
          ...sx
        }}
      />
    </div>
  )
}

PlayPauseIcon.propTypes = {
  sx: PropTypes.object,
  isPlaying: PropTypes.bool
}
